export const SPECIFICATION_STATE_VALUES = ['DRAFT', 'PRODUCTION'];
export const isSpecificationStateValue = (value) => SPECIFICATION_STATE_VALUES.includes(value);
export const splitStatusFilter = (values) => {
    const state = values.filter(isSpecificationStateValue);
    const statusId = values.filter((value) => !isSpecificationStateValue(value));
    return {
        state: state.length ? state : null,
        statusId: statusId.length ? statusId : null,
    };
};
